var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMembers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "24px",
    height: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#002851",
    d: "M 12 4 A 3.5 3.5 0 0 0 8.5 7.5 A 3.5 3.5 0 0 0 12 11 A 3.5 3.5 0 0 0 15.5 7.5 A 3.5 3.5 0 0 0 12 4 z M 4.5 7 A 2.5 2.5 0 0 0 2 9.5 A 2.5 2.5 0 0 0 4.5 12 A 2.5 2.5 0 0 0 7 9.5 A 2.5 2.5 0 0 0 4.5 7 z M 19.5 7 A 2.5 2.5 0 0 0 17 9.5 A 2.5 2.5 0 0 0 19.5 12 A 2.5 2.5 0 0 0 22 9.5 A 2.5 2.5 0 0 0 19.5 7 z M 12 13 C 9.664 13 5 14.173 5 16.5 L 5 19 C 5 19.552 5.448 20 6 20 L 18 20 C 18.552 20 19 19.552 19 19 L 19 16.5 C 19 14.173 14.336 13 12 13 z M 3.8984375 14.052734 C 2.3174375 14.296734 0 15.389078 0 16.705078 L 0 19 C 0 19.552 0.448 20 1 20 L 3 20 L 3 16.5 C 3 15.539 3.3454375 14.732734 3.8984375 14.052734 z M 20.101562 14.052734 C 20.654563 14.732734 21 15.539 21 16.5 L 21 20 L 23 20 C 23.552 20 24 19.552 24 19 L 24 16.705078 C 24 15.389078 21.682562 14.296734 20.101562 14.052734 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembers);
export default __webpack_public_path__ + "static/media/members.9a1240737c55f04567ff5c91f7a972f9.svg";
export { ForwardRef as ReactComponent };